import { Surface } from '../../ui/primitives/Surface.tsx';
import { Text } from '../../ui/primitives/Text.tsx';
import styles from './admin.module.css';

interface AdminAreaPlaceholderProps {
  title: string;
  description: string;
}

/**
 * What an admin area that isn't built yet looks like — named and described
 * as what it will be, not flagged as missing or disabled (the block itself
 * is fully reachable from the admin nav in `AppLayout`'s band; this is
 * what's inside it).
 */
export function AdminAreaPlaceholder({ title, description }: AdminAreaPlaceholderProps) {
  return (
    <div className={styles.page}>
      <Text as="h1" variant="heading">
        {title}
      </Text>
      <Surface layer={1} radius="lg" inset>
        <Text as="p" variant="body">
          {description}
        </Text>
        <Text as="p" variant="body-sm" tone="muted">
          Chegando em breve.
        </Text>
      </Surface>
    </div>
  );
}
